module.exports = __webpack_public_path__ + "img/body.8974b3e8.png";